/**
 * Sell-your-limiteds form.
 *
 * Posts through the app proxy so Shopify signs `logged_in_customer_id` onto the request —
 * the server identifies the seller from that signature rather than from anything this
 * page sends, so the offer can't be filed under someone else's account.
 */
(function () {
  var root = document.querySelector("[data-rbx-sell]");
  if (!root) return;

  var form = root.querySelector("[data-rbx-sell-form]");
  if (!form) return;

  var submit = root.querySelector("[data-rbx-sell-submit]");
  var status = root.querySelector("[data-rbx-sell-status]");
  var done = root.querySelector("[data-rbx-sell-done]");
  var gate = root.querySelector("[data-rbx-sell-gate]");
  var sending = false;

  var signedIn = root.dataset.signedIn === "true";

  /**
   * Sign-in happens at SEND, not on arrival.
   *
   * Making someone log in before they can even see the form is a wall in front of the one
   * thing the page is for. They can fill the whole thing out signed out; the account is
   * only needed at the moment we need somewhere to send the quote back to. The draft is
   * parked in localStorage across the round trip to Shopify's login, then sent on return,
   * so signing in costs them the typing they already did — which is the whole point.
   */
  var DRAFT_KEY = "rbx_quote_draft";

  function saveDraft(payload) {
    try {
      localStorage.setItem(DRAFT_KEY, JSON.stringify(payload));
    } catch (e) {}
  }

  function takeDraft() {
    try {
      var raw = localStorage.getItem(DRAFT_KEY);
      localStorage.removeItem(DRAFT_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function setError(field, message) {
    var node = root.querySelector('[data-rbx-error="' + field + '"]');
    if (node) node.textContent = message || "";
    var input = form.querySelector('[name="' + field + '"]');
    if (input) input.classList.toggle("rbx-sell__input--bad", !!message);
  }

  function clearErrors() {
    ["items", "username"].forEach(function (f) {
      setError(f, "");
    });
    if (status) {
      status.hidden = true;
      status.textContent = "";
    }
  }

  function showStatus(message) {
    if (!status) return;
    status.textContent = message;
    status.hidden = false;
  }

  function value(name) {
    var input = form.querySelector('[name="' + name + '"]');
    return input ? input.value.trim() : "";
  }

  /**
   * Opens the chat on a specific ticket. The widget exposes open(conversationId); the
   * bubble click is the fallback for when the widget script hasn't finished booting.
   */
  function openTicket(conversationId) {
    var widget = window.MessagingWidget;
    if (widget && typeof widget.open === "function") {
      widget.open(conversationId || undefined);
      return;
    }
    var bubble = document.querySelector(".mw-bubble");
    if (bubble) bubble.click();
  }

  var openButton = root.querySelector("[data-rbx-sell-open]");
  if (openButton) {
    openButton.addEventListener("click", function (event) {
      event.preventDefault();
      var host = root.querySelector("[data-rbx-sell-done]");
      openTicket(host && host.dataset.conversationId);
    });
  }

  function collect() {
    var method = value("payment");
    return {
      items: value("items"),
      username: value("username"),
      // An "Other …" choice is only meaningful together with what they typed, so the two
      // are collapsed into one value before it leaves the page.
      payment: /^Other/.test(method) && value("paymentOther")
        ? method + ": " + value("paymentOther")
        : method,
    };
  }

  function sendQuote(payload) {
    sending = true;
    if (submit) {
      submit.disabled = true;
      submit.textContent = "Sending\u2026";
    }

    return fetch("/apps/messages/sell", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, status: response.status, data: data };
        });
      })
      .then(function (result) {
        if (result.ok && result.data && result.data.ok) {
          form.hidden = true;
          if (gate) gate.hidden = true;
          if (done) {
            done.hidden = false;
            done.dataset.conversationId = result.data.conversationId || "";
          }
          root.scrollIntoView({ behavior: "smooth", block: "start" });
          openTicket(result.data.conversationId);
          return;
        }

        if (result.status === 401) {
          // The signed-in flag came from the page, which can be stale on a cached render.
          // Falling back to the gate keeps their typing rather than losing it to an error.
          saveDraft(payload);
          showGate();
        } else {
          showStatus(
            (result.data && result.data.error) ||
              "That didn't send. Try again, or message us directly.",
          );
        }
      })
      .catch(function () {
        showStatus("That didn't send \u2014 check your connection and try again.");
      })
      .finally(function () {
        sending = false;
        if (submit) {
          submit.disabled = false;
          submit.textContent = "Get a quote";
        }
      });
  }

  function showGate() {
    if (!gate) return;
    gate.hidden = false;
    gate.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  function missingFields(payload) {
    // Checked here as well as on the server. The server is the one that counts; this is
    // only so the seller sees which box is empty without a round trip.
    return [
      ["items", "Tell us which limiteds you want quoted."],
      ["username", "We need the account the items are on."],
    ].filter(function (pair) {
      return !payload[pair[0]];
    });
  }

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    if (sending) return;
    clearErrors();

    var payload = collect();
    var blank = missingFields(payload);

    if (blank.length) {
      blank.forEach(function (pair) {
        setError(pair[0], pair[1]);
      });
      var first = form.querySelector('[name="' + blank[0][0] + '"]');
      if (first) first.focus();
      return;
    }

    // Validated first on purpose: sending someone to log in only to bounce them back to
    // an error would waste the round trip.
    if (!signedIn) {
      saveDraft(payload);
      showGate();
      return;
    }

    sendQuote(payload);
  });

  var signinButton = root.querySelector("[data-rbx-sell-signin]");
  var registerButton = root.querySelector("[data-rbx-sell-register]");

  function leaveTo(url) {
    // Re-saved on the way out: they may have edited a field after the gate appeared.
    var payload = collect();
    if (payload.items || payload.username) saveDraft(payload);
    window.location.href = url;
  }

  if (signinButton) {
    signinButton.addEventListener("click", function () {
      leaveTo(root.dataset.loginUrl || "/account/login");
    });
  }
  if (registerButton) {
    registerButton.addEventListener("click", function () {
      leaveTo(root.dataset.registerUrl || "/account/register");
    });
  }

  /**
   * Payment dropdown.
   *
   * Hand-rolled because a native <select> cannot show a logo next to an option. The value
   * lives in a hidden input, so everything downstream — validation, the payload — treats it
   * as an ordinary form field.
   */
  var payRoot = root.querySelector("[data-rbx-payment]");
  var payTrigger = root.querySelector("[data-rbx-payment-trigger]");
  var payMenu = root.querySelector("[data-rbx-payment-menu]");
  var payLabel = root.querySelector("[data-rbx-payment-label]");
  var payValue = root.querySelector("[data-rbx-payment-value]");
  var paymentOther = root.querySelector("[data-rbx-payment-other]");

  if (payRoot && payTrigger && payMenu) {
    var openMenu = function (open) {
      payMenu.hidden = !open;
      payTrigger.setAttribute("aria-expanded", open ? "true" : "false");
      payRoot.classList.toggle("rbx-pay--open", open);
    };

    payTrigger.addEventListener("click", function () {
      openMenu(payMenu.hidden);
    });

    payMenu.addEventListener("click", function (event) {
      var option = event.target.closest("[data-rbx-payment-option]");
      if (!option) return;

      payValue.value = option.dataset.value;

      // Rebuild the trigger to show the chosen mark, so the closed dropdown carries the
      // logo too rather than dropping back to plain text.
      payLabel.innerHTML = "";
      var mark = document.createElement("span");
      mark.className = "rbx-pay__mark rbx-pay__mark--" + option.dataset.slug;
      mark.setAttribute("aria-hidden", "true");
      mark.textContent = option.dataset.glyph;
      var name = document.createElement("span");
      name.className = "rbx-pay__name";
      name.textContent = option.dataset.value;
      payLabel.appendChild(mark);
      payLabel.appendChild(name);

      payMenu.querySelectorAll("[data-rbx-payment-option]").forEach(function (node) {
        node.setAttribute("aria-selected", node === option ? "true" : "false");
      });

      // Both "Other crypto" and "Other app" open the free-text box, each asking for the
      // right thing — a coin or an app — rather than one vague prompt covering both.
      if (paymentOther) {
        var prompt = option.dataset.prompt || "";
        paymentOther.hidden = !prompt;
        if (prompt) {
          paymentOther.placeholder = prompt;
          paymentOther.focus();
        } else {
          paymentOther.value = "";
        }
      }

      openMenu(false);
    });

    document.addEventListener("click", function (event) {
      if (!payRoot.contains(event.target)) openMenu(false);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !payMenu.hidden) {
        openMenu(false);
        payTrigger.focus();
      }
    });
  }

  // Clear a field's error as soon as the seller starts fixing it.
  ["items", "username"].forEach(function (name) {
    var input = form.querySelector('[name="' + name + '"]');
    if (!input) return;
    input.addEventListener("input", function () {
      if (input.value.trim()) setError(name, "");
    });
  });

  /**
   * Coming back from login with a draft parked.
   *
   * The fields are refilled before the send rather than after, so if the request fails
   * the form they left with is the form they land on — nothing of theirs is riding only
   * on the network call succeeding.
   */
  function restore(draft) {
    var itemsInput = form.querySelector('[name="items"]');
    var userInput = form.querySelector('[name="username"]');
    if (itemsInput) itemsInput.value = draft.items || "";
    if (userInput) userInput.value = draft.username || "";

    if (!draft.payment) return;
    // "Other crypto: LTC" is stored as one string; the part before the colon is the
    // option, the rest is what they typed into the free-text box.
    var split = draft.payment.indexOf(": ");
    var choice = split > -1 ? draft.payment.slice(0, split) : draft.payment;
    var extra = split > -1 ? draft.payment.slice(split + 2) : "";

    var option = payMenu
      ? payMenu.querySelector('[data-rbx-payment-option][data-value="' + choice + '"]')
      : null;
    if (option) {
      option.click();
      if (extra && paymentOther) paymentOther.value = extra;
    }
  }

  if (signedIn) {
    var draft = takeDraft();
    if (draft && (draft.items || draft.username)) {
      restore(draft);
      if (!missingFields(draft).length) {
        showStatus("Signed in \u2014 sending your quote\u2026");
        sendQuote(draft);
      }
    }
  }
})();
